module.exports = __webpack_public_path__ + "img/discounts.23bc4783.svg";